var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMilk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6157 18.8438C39.6157 19.6243 39.2711 20.2936 38.7691 20.6082C41.0217 23.6522 43.2993 28.6061 43.4114 28.8509L43.5521 29.1536V29.486V57.1848C43.5521 60.0585 41.1934 62.4 38.2945 62.4H27.4716C24.5775 62.4 22.2188 60.0585 22.2188 57.1848V29.486V29.156L22.3559 28.8509C22.3576 28.8473 22.3597 28.8426 22.3623 28.8369C22.5366 28.4596 24.779 23.6059 26.9994 20.607C26.4973 20.2936 26.1539 19.6231 26.1539 18.8426C26.1539 17.764 26.8133 16.8889 27.6278 16.8889H38.1395C38.9539 16.8889 39.6157 17.764 39.6157 18.8438ZM23.7646 29.486C23.7646 29.486 29.0187 32.2461 32.7285 29.486C36.4359 26.7281 42.0023 29.486 42.0023 29.486C42.0023 29.486 39.2704 23.5126 36.9594 20.7986H28.8076C26.4942 23.5126 23.7646 29.486 23.7646 29.486Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.468 62.0152L44.1865 44.791H57.1047L55.8243 62.0152H45.468ZM45.4587 49.6328C45.4587 49.6328 49.2272 50.7054 50.7439 49.6567C52.2253 48.63 55.6635 49.6292 55.8222 49.6753C55.826 49.6764 55.8279 49.677 55.8278 49.6769L56.1193 45.7205H45.1649L45.4587 49.6328Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.73975fac9b692854430778d26dcd8653.svg";
export { ForwardRef as ReactComponent };